import { createSelector } from '@ngrx/store'

import { AppState } from '../../../../store/app.state'
import * as fromSignal from '../reducers/signalR.reducer'

export const selectSignalState = (state: AppState) => state.signal

export const getSignalStatus = createSelector(
  selectSignalState,
  fromSignal.getStatus
)



// WEBPACK FOOTER //
// ./src/app/shared/signalR/store/selectors/signalR.selectors.ts